/**
 * E-postadaki tek kullanımlık bağlantının belirteci (M7 T2: davet kabulü, parola sıfırlama).
 *
 * Belirteç bağlantının URL PARÇASINDA gelir (`/invite#token=…`): tarayıcı parçayı sunucuya göndermez, böylece belirteç web
 * sunucusunun erişim günlüğüne ve `Referer` başlığına düşmez. Sayfa belirteci ilk çizimde belleğe alır ve adres çubuğundan
 * hemen kaldırır (geçmiş kaydı DEĞİŞTİRİLİR, yeni kayıt eklenmez): belirteç ekranda, kopyalanan adreste ve "geri" geçmişinde
 * kalmaz. Belirteç yalnız bileşen belleğindedir — yerel depoya, çereze, günlüğe ya da hata iletisine yazılmaz; yalnız aynı
 * kökendeki API'ye istek gövdesinde gönderilir.
 *
 * Sorgu biçimi (`?token=…`) yalnız yedek olarak okunur (parçayı düşüren bir posta aracı için); o da aynı biçimde kaldırılır.
 */
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/** Sunucunun ürettiği opak belirteç biçimi (base64url); `acceptInviteInputSchema` / `resetPasswordInputSchema` sınırlarıyla aynı */
const TOKEN_RE = /^[A-Za-z0-9_-]{20,200}$/;

/** Adresteki belirteç; yoksa ya da biçimi tanınmıyorsa `null` (biçimi bozuk değer API'ye hiç gönderilmez). */
export function readLinkToken(hash: string, search: string): string | null {
  const fromHash = new URLSearchParams(hash.replace(/^#/, '')).get('token');
  const raw = fromHash ?? new URLSearchParams(search).get('token');
  return raw !== null && TOKEN_RE.test(raw) ? raw : null;
}

/**
 * Belirteci belleğe alır ve adres çubuğunu temizler. Dönen değer sayfa açık kaldıkça sabittir; sayfa yenilenirse belirteç
 * kaybolur (bağlantı e-postadan yeniden açılır).
 */
export function useLinkToken(): string | null {
  const location = useLocation();
  const navigate = useNavigate();
  const [token] = useState(() => readLinkToken(location.hash, location.search));
  const carriesData = location.hash !== '' || location.search !== '';
  useEffect(() => {
    if (carriesData) navigate(location.pathname, { replace: true });
  }, [carriesData, location.pathname, navigate]);
  return token;
}
